import { FC } from "react";
import { IconProps } from "./types";

export const ViewToggleList: FC<IconProps> = ({
  fill = "#111",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm0 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3-1.5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H7zM6.5 12a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5zM7 5.5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H7z"
      fill={fill}
    />
  </svg>
);
